import React, { CSSProperties, FC } from 'react'
import { HeroImageProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { spacings } from '@sport1/news-styleguide/spacings'
import ArticleTeaser from '@sport1/news-styleguide/ArticleTeaser'
import Font from '@sport1/news-styleguide/Font'
import colorPattern from '@sport1/news-styleguide/colorPattern'

import Image from 'next/image'
import { TOP_MEDIA_MAX_HEIGHT, TOP_MEDIA_MAX_WIDTH } from '@/utils/content/constants'
import { sport1Regular } from '@/helpers/fonts'
import { useTopMediaDimensions } from '@/hooks/useTopMediaDimensions'
import { PLACEHOLDER_BLUR_BASE64, transformImageUrlToSize } from '@/helpers/imageHelper'

type Props = {
    content: HeroImageProps
}

const textStyle = {
    backgroundImage: 'linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0))',
    bottom: '0',
    padding: spacings['spacing-6'],
    position: 'absolute',
    width: '100%',
} as CSSProperties

const RATIO = TOP_MEDIA_MAX_WIDTH / TOP_MEDIA_MAX_HEIGHT

const ArticleTopImage: FC<Props> = ({ content }) => {
    const { width, height } = useTopMediaDimensions()

    return (
        <NonFlexingContainer
            className="article-top-image-wrapper"
            position="relative"
            testID="article-top-image"
        >
            <ArticleTeaser
                type="TopImage"
                size="M"
                imageUrlArray={[{ src: content.imageUrl, alt: content.description }]}
                // NOTE: Temporary hack for performance boost // TODO: We need to refactor teasers and every component with image to use Next Image
                nextImage={
                    <div
                        style={{ position: 'relative', width: '100%', aspectRatio: String(RATIO) }}
                    >
                        <Image
                            id="article-teaser-image_baseImage"
                            src={transformImageUrlToSize(content?.imageUrl, width, height)}
                            alt={content?.description || ''}
                            style={{ objectFit: 'cover' }}
                            fill
                            priority
                            sizes="(max-width: 1024px) 100vw, 1041px"
                            quality={75}
                            placeholder="blur"
                            blurDataURL={PLACEHOLDER_BLUR_BASE64}
                        />
                    </div>
                }
            />

            <div style={textStyle}>
                <Font
                    nextFontFamilyVariant={sport1Regular.style.fontFamily}
                    color={colorPattern.pearl}
                    fontSize={['font-size-3', 'font-size-4', 'font-size-4']}
                    lineHeight={['lineHeight-20', 'lineHeight-22', 'lineHeight-22']}
                >
                    {content.title}
                </Font>
                <Font
                    nextFontFamilyVariant={sport1Regular.style.fontFamily}
                    color={colorPattern.pearl}
                    fontSize={['font-size-3', 'font-size-4', 'font-size-4']}
                    lineHeight={['lineHeight-20', 'lineHeight-22', 'lineHeight-22']}
                >{`© ${content.copyright}`}</Font>
            </div>
        </NonFlexingContainer>
    )
}

export default ArticleTopImage
